import noop from 'lodash/noop';
import { createContext } from 'react';
import { CrudContextValues } from './types';

export default createContext<CrudContextValues>({
    onPreventClose: noop,
});
